// Responsive variants for Ghost-hosted images.
//
// The blog listing was serving 24 full-size originals - ~150KB each, one of
// them 298KB, ~3.6MB for the page - into cards that render about 350px wide.
// Ghost already exposes resized copies at /content/images/size/wN/..., which
// it generates on demand, and the w600 variant of a 74KB original is 25KB.

// Widths cover a ~350px card at 1x through 3x, and a full-bleed phone card.
const WIDTHS = [300, 600, 900]

// Only Ghost's own image paths can be resized. Anything else - an external
// URL, or a path shaped differently by a future Ghost version - is returned
// untouched rather than rewritten into a 404.
const GHOST_IMAGE_PATH = '/content/images/'

export function isResizableGhostImage(url) {
  return typeof url === 'string' && url.includes(GHOST_IMAGE_PATH)
}

// Idempotent: an already-resized URL is re-sized rather than nested, so
// passing a variant back through cannot produce .../size/w600/size/w600/...
export function ghostImageUrl(url, width) {
  if (!isResizableGhostImage(url)) {
    return url
  }

  const original = url.replace(
    new RegExp(`${GHOST_IMAGE_PATH}size/w\\d+/`),
    GHOST_IMAGE_PATH
  )

  return original.replace(
    GHOST_IMAGE_PATH,
    `${GHOST_IMAGE_PATH}size/w${width}/`
  )
}

export function ghostImageSrcset(url, widths = WIDTHS) {
  if (!isResizableGhostImage(url)) {
    return null
  }

  return widths.map((w) => `${ghostImageUrl(url, w)} ${w}w`).join(', ')
}

// Card is roughly a third of a 1120px container on desktop, half the viewport
// on tablet, and full-bleed on a phone.
export const CARD_SIZES =
  '(min-width: 1024px) 352px, (min-width: 769px) 46vw, 92vw'

export { WIDTHS }
